/* Norvu home island — vanilla JS. */
(function () {
  /* ---- Hero carousel ---- */
  document.querySelectorAll('[data-hero]').forEach(hero => {
    const slides = hero.querySelectorAll('[data-hero-slide]');
    const dots = hero.querySelectorAll('[data-hero-dot]');
    if (slides.length < 2) return;
    let i = 0, timer;
    const go = (n) => {
      i = (n + slides.length) % slides.length;
      slides.forEach((s, idx) => s.classList.toggle('is-active', idx === i));
      dots.forEach((d, idx) => d.classList.toggle('is-active', idx === i));
    };
    slides[0].classList.add('is-active');
    dots.forEach((d, idx) => d.addEventListener('click', () => { go(idx); reset(); }));
    const reset = () => { clearInterval(timer); timer = setInterval(() => go(i + 1), 5000); };
    reset();
  });

  /* ---- Tabbed hero ----
     Sets body.is-cat-hair/is-cat-skin AND dispatches `norvu:category-change`
     so sections can react either via CSS (preferred) or JS. */
  document.querySelectorAll('[data-hero-tab]').forEach(root => {
    const tabs = root.querySelectorAll('[data-tab]');
    const panels = root.querySelectorAll('[data-panel]');
    const setCat = (id) => {
      document.body.classList.remove('is-cat-hair', 'is-cat-skin');
      if (id) {
        document.body.classList.add('is-cat-' + id);
        window.dispatchEvent(new CustomEvent('norvu:category-change', { detail: { category: id } }));
      }
    };
    const initial = root.querySelector('[data-tab].is-active');
    if (initial) setCat(initial.dataset.tab);
    tabs.forEach(t => t.addEventListener('click', () => {
      const id = t.dataset.tab;
      tabs.forEach(x => {
        const active = x === t;
        x.classList.toggle('is-active', active);
        x.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      panels.forEach(p => p.classList.toggle('is-active', p.dataset.panel === id));
      setCat(id);
    }));
  });

  /* ---- Product grid carousel ---- */
  document.querySelectorAll('[data-pg-carousel]').forEach(root => {
    const scroller = root.querySelector('[data-pg-scroller]');
    const next = root.querySelector('[data-pg-next]');
    if (!scroller || !next) return;
    const step = () => {
      const first = scroller.querySelector('li');
      if (!first) return scroller.clientWidth * 0.8;
      const second = first.nextElementSibling;
      if (second) return second.getBoundingClientRect().left - first.getBoundingClientRect().left;
      return first.getBoundingClientRect().width + 24;
    };
    const advance = () => scroller.scrollBy({ left: step(), behavior: 'smooth' });
    next.addEventListener('click', advance);
    next.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); advance(); } });
  });
})();
